<template>
<div class="obj-major-info-title">
  <div class="icon-box">
    <span class="icon"><i :class="iconClass"></i></span>
    <span v-show="showState" :class="['state', stateClass ]" >
      <i class="fas fa-circle text-mini"></i>
    </span>
  </div>
  <div class="title-box">
    <div :class="['title', { clickable: clickableTitle} ]" @click="onNameClick">
      <span>{{ getValueAfterCheckEmpty(title) }} <i v-show="clickableTitle" class="fas fa-external-link-square-alt"></i></span>
    </div>
    <span class="sub-title">{{ isNil(subTitle) ? '' : subTitle }}</span>
  </div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WManagedObjectTitle',
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    iconClass: {
      type: String,
    },
    state: {
      type: [String, Number, Boolean],
    },
    showState: {
      type: Boolean,
      default: false,
    },
    clickableTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    stateClass() {
      if (this.showState && !isNil(this.state)) {
        return isTrue(this.state) ? 'state-up' : 'state-down';
      }
      return null;
    },
  },
  methods: {
    isNil,
    getValueAfterCheckEmpty,
    onNameClick() {
      if (this.clickableTitle) {
        this.$emit('title-click');
      }
    },
  },
};
</script>

<style lang="scss">
.obj-major-info-title {
  .icon-box {
    position: absolute;
    width: 40px;
    height: 30px;
    color: #999;

    .icon {
      position: absolute;
      font-size: 30px;
    }

    .state {
      position: absolute;
      font-size: 12px;
      right: -5px;
      bottom: -5px;
    }
  }

  .title-box {
    display: grid;
    width: 250px;
    margin-left: 50px;
    .title {
      font-size: 15px;
      font-weight: 400;
      color: #333;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      i {
        font-size: 12px;
        font-weight: 400;
      }
      &.clickable {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .sub-title {
      font-size: 11px;
      font-weight: 400;
      color: #666;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/ManagedObjectTitle.vue